import React from 'react';

/**
 * Enhanced header with premium styling, matches sidebar with amber accents.
 */
function Header({
  showUser = true,
  userName = 'Admin',
  onMobileMenuClick,
  showMobileMenuButton = true,
}) {
  const initial = (userName || 'A')[0].toUpperCase();

  return (
    <header className="sticky top-0 z-20 h-16 shrink-0 border-b border-amber-500/20 shadow-lg shadow-black/20">
      {/* Subtle top highlight */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-400/30 to-transparent" />
      <div className="relative flex items-center justify-between h-full px-4 lg:px-6">
        {/* Left: mobile menu */}
        {showMobileMenuButton && onMobileMenuClick && (
          <button
            onClick={onMobileMenuClick}
            className="lg:hidden p-2.5 rounded-xl hover:bg-amber-500/15 text-slate-400 hover:text-amber-400 transition-all duration-200"
            aria-label="Open menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        )}

        {/* Spacer / future: page title */}
        <div className="flex-1 min-w-0" />

        {/* Right: user profile */}
        {showUser && (
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-3 pl-4 py-1.5 pr-4 rounded-xl bg-white/5 border border-white/10 hover:border-amber-500/20 hover:bg-amber-500/5 transition-all duration-200">
              <div className="w-9 h-9 rounded-lg bg-amber-500/20 flex items-center justify-center shrink-0 ring-1 ring-amber-400/20">
                <span className="text-sm font-semibold text-amber-400">{initial}</span>
              </div>
              <div className="hidden sm:block">
                <p className="text-sm font-medium text-white">{userName}</p>
                <p className="text-xs text-slate-500">Admin</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
